import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as userActions from "../../actions/userActions";
import * as departmentActions from "../../actions/departmentActions";
import * as roleActions from "../../actions/roleActions";
import * as codeActions from "../../actions/codeActions";

import HeaderWrapper from "../common/HeaderWrapper";
import UserForm from "./UserForm";

class UserAddPage extends Component {
  componentDidMount = () => {
    const { users, roles, departments, actions } = this.props;
    if (!roles.length) actions.loadRoles();
    if (!departments.length) actions.loadDepartments();

    if (!users.length) actions.loadUsers();
  };

  handleSave = (user) => {
    this.props.actions.createUser(user);
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  render() {
    const { users, savingUser, roles, codes, departments } = this.props;

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: "Settings" }, { label: "New User" }]}
        />
        <div className="content-wrapper">
          <UserForm
            user={{}}
            users={users}
            roles={roles}
            codes={codes}
            departments={departments}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
            saving={savingUser}
            editing
            adding
          />
        </div>
      </>
    );
  }
}

UserAddPage.propTypes = {
  actions: PropTypes.object.isRequired,
  savingUser: PropTypes.bool,
  users: PropTypes.array,
  departments: PropTypes.array,
  codes: PropTypes.array,
  roles: PropTypes.array,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    savingUser: state.reducers.savingUser,
    departments: state.reducers.departments,
    codes: state.reducers.codes,
    roles: state.reducers.roles,
    users: state.reducers.users
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...departmentActions,
        ...codeActions,
        ...roleActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(UserAddPage);
